import type { StammdatenOmdSelection } from '../../../../utils/stammdatenRoutes';
import type { Material } from '../../types/material';
import type { OmdPanelMaterial } from './types';
import {
  asOmdProduct,
  cleanOmdText,
  extractOmdEnergyClass,
  type OmdProduct,
} from '../../utils/omdProductView';

export function resolveArticleNumber(m: OmdPanelMaterial): string {
  return String(m.article_number ?? m.gtin ?? '').trim();
}

export function materialMatchesOmdSelection(
  m: OmdPanelMaterial,
  selection: StammdatenOmdSelection,
): boolean {
  const slug = String(m.supplier_slug ?? '').trim().toLowerCase();
  if (slug !== selection.supplierSlug) return false;
  const article = String(m.article_number ?? '').trim();
  const gtin = String(m.gtin ?? '').trim();
  return (
    resolveArticleNumber(m) === selection.article ||
    article === selection.article ||
    gtin === selection.article
  );
}

/** Minimal catalog row so a shared OMD link can open without the article being on the current list page. */
export function stubMaterialFromOmdSelection(selection: StammdatenOmdSelection): Material {
  const { supplierSlug, article } = selection;
  return {
    id: `omd:${supplierSlug}:${article}`,
    name: article,
    brand: null,
    supplier: null,
    gtin: article,
    unit: null,
    net_price: null,
    surcharge_percent: null,
    vat_percent: null,
    gross_price: null,
    description: null,
    minutes: null,
    folder_id: null,
    created_at: null,
    kind: 'shared',
    supplier_slug: supplierSlug,
    article_number: article,
  };
}

export { isOmdCatalogMaterial } from '../../utils/materialForm';

export function resolveOmdHeaderInfo(material: OmdPanelMaterial, product: unknown | null) {
  const data = product ? asOmdProduct(product) : null;
  const title =
    (data ? cleanOmdText(data.basic?.productShortDescr) : '') ||
    material.name ||
    'Produktdetails';
  const articleNumber =
    (data?.manufacturerPid != null ? String(data.manufacturerPid).trim() : '') ||
    (data?.supplierPid != null ? String(data.supplierPid).trim() : '') ||
    resolveArticleNumber(material);
  const gtin =
    data?.gtin != null
      ? String(data.gtin).trim()
      : material.gtin != null
        ? String(material.gtin).trim()
        : '';
  const brand = (material.brand || data?.manufacturerId || '').trim();
  const productType = data?.basic?.productType;
  const energyClass = data ? extractOmdEnergyClass(data) : null;

  return { title, articleNumber, gtin, brand, productType, energyClass, data };
}

export function requireOmdProduct(product: unknown): OmdProduct | null {
  return asOmdProduct(product);
}
